import React, {use, useEffect, useState} from 'react';
import {Card, Typography, Row, Col, Statistic} from 'antd';
import {ExperimentOutlined, UserOutlined, DatabaseOutlined, ClockCircleOutlined} from '@ant-design/icons';
import api from "../services/api";
import apiService from "../services/api";

const {Title} = Typography;

const Home = () => {
    const [systemInfo, setSystemInfo] = useState({});

    useEffect(() => {
        apiService.system.getSystemInfo()
            .then(response => {
                console.log(response.data);
                setSystemInfo(prevState => {
                    return {
                        ...prevState,
                        formulaCount: response.data.formulaCount,
                        userCount: response.data.userCount,
                        colorTypeCount: response.data.colorTypeCount,
                        todayOperationCount: response.data.todayOperationCount,
                    }
                })
            })
            .catch(error => {
                console.log(error);
            });
    }, []);
    return (
        <div className="home-container" style={{padding: '24px'}}>
            <Title level={2}>欢迎使用染发配方管理系统</Title>
            <div style={{marginBottom: '24px'}}>
                <Typography.Paragraph>
                    这里是系统的首页，您可以查看系统概况和数据统计信息。
                </Typography.Paragraph>
            </div>

            <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={6}>
                    <Card>
                        <Statistic
                            title="配方总数"
                            value={systemInfo.formulaCount}
                            prefix={<ExperimentOutlined/>}
                            valueStyle={{color: '#1890ff'}}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Card>
                        <Statistic
                            title="用户数量"
                            value={systemInfo.userCount}
                            prefix={<UserOutlined/>}
                            valueStyle={{color: '#52c41a'}}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Card>
                        <Statistic
                            title="色系分类"
                            value={systemInfo.colorTypeCount}
                            prefix={<DatabaseOutlined/>}
                            valueStyle={{color: '#722ed1'}}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Card>
                        <Statistic
                            title="今日操作"
                            value={systemInfo.todayOperationCount}
                            prefix={<ClockCircleOutlined/>}
                            valueStyle={{color: '#fa8c16'}}
                        />
                    </Card>
                </Col>
            </Row>

            <Card style={{marginTop: '24px'}}>
                <Title level={4}>系统公告</Title>
                <Typography.Paragraph>
                    • 欢迎使用染发配方管理系统 V1.0 版本
                </Typography.Paragraph>
                <Typography.Paragraph>
                    • 系统支持配方的添加、编辑、删除等功能
                </Typography.Paragraph>
                <Typography.Paragraph>
                    • 如有问题请联系系统管理员
                </Typography.Paragraph>
            </Card>
        </div>
    );
};

export default Home;